import axios from "axios";
import toast from "react-hot-toast";

export const FETCH_PARK_ATTENDANCE_REQUEST = "FETCH_PARK_ATTENDANCE_REQUEST";
export const FETCH_PARK_ATTENDANCE_SUCCESS = "FETCH_PARK_ATTENDANCE_SUCCESS";
export const FETCH_PARK_ATTENDANCE_FAILURE = "FETCH_PARK_ATTENDANCE_FAILURE";

export const DELETE_PARK_ATTENDANCE_REQUEST = "DELETE_PARK_ATTENDANCE_REQUEST";
export const DELETE_PARK_ATTENDANCE_SUCCESS = "DELETE_PARK_ATTENDANCE_SUCCESS";
export const DELETE_PARK_ATTENDANCE_FAILURE = "DELETE_PARK_ATTENDANCE_FAILURE";
export const FETCH_ATTENDANCE_DEFAULTERS_REQUEST = "FETCH_ATTENDANCE_DEFAULTERS_REQUEST";
export const FETCH_ATTENDANCE_DEFAULTERS_SUCCESS = "FETCH_ATTENDANCE_DEFAULTERS_SUCCESS";
export const FETCH_ATTENDANCE_DEFAULTERS_FAILURE = "FETCH_ATTENDANCE_DEFAULTERS_FAILURE";

export const FETCH_PROJECT_WISE_DEFAULTERS_REQUEST = "FETCH_PROJECT_WISE_DEFAULTERS_REQUEST";
export const FETCH_PROJECT_WISE_DEFAULTERS_SUCCESS = "FETCH_PROJECT_WISE_DEFAULTERS_SUCCESS";
export const FETCH_PROJECT_WISE_DEFAULTERS_FAILURE = "FETCH_PROJECT_WISE_DEFAULTERS_FAILURE";


export const FETCH_PROJECT_ATTENDANCE_REQUEST = "FETCH_PROJECT_ATTENDANCE_REQUEST";
export const FETCH_PROJECT_ATTENDANCE_SUCCESS = "FETCH_PROJECT_ATTENDANCE_SUCCESS";
export const FETCH_PROJECT_ATTENDANCE_FAILURE = "FETCH_PROJECT_ATTENDANCE_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * FETCH PARK ATTENDANCE
 */
export const fetchParkAttendance = ({
  page = 1,
  limit = 10,
  district = "",
  municipality = "",
  fromDate = "",
  toDate = "",
  search = "",
  designation = "",
  project_type = "", 
} = {}) => {
  return async (dispatch) => {

    dispatch({ type: FETCH_PARK_ATTENDANCE_REQUEST });

    const token = localStorage.getItem("token");

    const queryParams = new URLSearchParams({
      page,
      limit,
      district,
      municipality,
      fromDate,
      toDate,
      search,
      designation,
       project_type,  
    }).toString();

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/getAllParkAttendance?${queryParams}`,
        {
          headers: {
            authorization: token,
          },
        }
      );

      dispatch({
        type: FETCH_PARK_ATTENDANCE_SUCCESS,
        payload: {
          attendance: response.data.data,
          pagination: response.data.pagination,
        },
      });

    } catch (error) {
      let message = "Failed to fetch park attendance";

      if (error?.response?.data?.meta?.message) {
        message = error.response.data.meta.message;
      } else if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }

      dispatch({
        type: FETCH_PARK_ATTENDANCE_FAILURE,
        payload: message,
      });
    }
  };
};

/**
 * DELETE PARK ATTENDANCE
 */
export const deleteParkAttendance = (id) => {
  return async (dispatch) => {

    dispatch({ type: DELETE_PARK_ATTENDANCE_REQUEST });

    const token = localStorage.getItem("token");

    try {
      await axios.delete(
        `${BASE_URL}/v1/api/adminPark/deleteAttendance/${id}`,
        {
          headers: {
            authorization: token,
          },
        }
      );

      dispatch({
        type: DELETE_PARK_ATTENDANCE_SUCCESS,
        payload: id,
      });

      toast.success("Park attendance deleted successfully");

    } catch (error) {
      let message = "Failed to delete park attendance";

      if (error?.response?.data?.meta?.message) {
        message = error.response.data.meta.message;
      } else if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }

      dispatch({
        type: DELETE_PARK_ATTENDANCE_FAILURE,
        payload: message,
      });

      toast.error(message);
    }
  };
};

/**
 * FETCH ATTENDANCE DEFAULTERS
 */
export const fetchAttendanceDefaulters = ({
  page = 1,
  limit = 10,
  district = "",
  municipality = "",
  fromDate = "",
  toDate = "",
  search = "",
  designation = "",
  project_type = "",
} = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ATTENDANCE_DEFAULTERS_REQUEST });

    const token = localStorage.getItem("token");

    // Build query params WITHOUT setting default dates
    const params = {
      page,
      limit,
    };

    // Only add parameters if they have values
    if (district) params.district = district;
    if (municipality) params.municipality = municipality;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    if (search) params.search = search;
    if (designation) params.designation = designation;
    if (project_type) params.project_type = project_type;

    const queryParams = new URLSearchParams(params).toString();

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/getAttendanceDefaulters?${queryParams}`,
        {
          headers: {
            authorization: token,
          },
        }
      );

      dispatch({
        type: FETCH_ATTENDANCE_DEFAULTERS_SUCCESS,
        payload: {
          defaulters: response.data.data,
          pagination: response.data.pagination,
        },
      });
    } catch (error) {
      let message = "Failed to fetch attendance defaulters";

      if (error?.response?.data?.meta?.message) {
        message = error.response.data.meta.message;
      } else if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }

      dispatch({
        type: FETCH_ATTENDANCE_DEFAULTERS_FAILURE,
        payload: message,
      });

      toast.error(message);
    }
  };
};

/**
 * FETCH PROJECT WISE ATTENDANCE DEFAULTERS
 */
export const fetchProjectWiseAttendanceDefaulters = ({
  page = 1,
  limit = 10,
  district = "",
  municipality = "",
  fromDate = "",
  toDate = "",
  search = "",
  project_type = "",
} = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_PROJECT_WISE_DEFAULTERS_REQUEST });

    const token = localStorage.getItem("token");

    // Build params dynamically
    const params = {
      page,
      limit,
    };

    if (district) params.district = district;
    if (municipality) params.municipality = municipality;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    if (search) params.search = search;
    if (project_type) params.project_type = project_type;

    const queryParams = new URLSearchParams(params).toString();

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/projectWiseAttendanceDefaulters?${queryParams}`,
        {
          headers: {
            authorization: token,
          },
        }
      );

      dispatch({
        type: FETCH_PROJECT_WISE_DEFAULTERS_SUCCESS,
        payload: {
          defaulters: response.data.data,
          pagination: response.data.pagination,
        },
      });
    } catch (error) {
      let message = "Failed to fetch project-wise attendance defaulters";

      if (error?.response?.data?.meta?.message) {
        message = error.response.data.meta.message;
      } else if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }

      dispatch({
        type: FETCH_PROJECT_WISE_DEFAULTERS_FAILURE,
        payload: message,
      });

      toast.error(message);
    }
  };
};

/**
 * FETCH PROJECT ATTENDANCE (Shelter / Park / Stretch)
 */
// In your ParkAttendanceActions.js

export const fetchProjectAttendance = ({
  page = 1,
  limit = 10,
  district = "",
  municipality = "",
  from_date = "",
  to_date = "",
  project_type = "",
} = {}) => {
  return async (dispatch) => {

    dispatch({ type: FETCH_PROJECT_ATTENDANCE_REQUEST });

    const token = localStorage.getItem("token");

    /* ✅ build query params EXACTLY like backend */
    const params = {
      page,
      limit,
    };

    // Only add parameters if they have values
    if (project_type) params.project_type = project_type;
    if (district) params.district = district;
    if (municipality) params.municipality = municipality;
    if (from_date) params.from_date = from_date;
    if (to_date) params.to_date = to_date;

    const queryParams = new URLSearchParams(params).toString();

    console.log("API URL:", `${BASE_URL}/v1/api/getProjectAttendance?${queryParams}`);
    console.log("Params:", params);

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/getProjectAttendance?${queryParams}`,
        {},
        {
          headers: {
            authorization: token,
          },
        }
      );

      console.log("API Response:", response.data);

      dispatch({
        type: FETCH_PROJECT_ATTENDANCE_SUCCESS,
        payload: {
          data: response.data.data || [],
          summary: response.data.summary || {},
          pagination: response.data.pagination || {},
        },
      });

    } catch (error) {
      console.error("API Error:", error);

      let message = "Failed to fetch project attendance";

      if (error?.response?.data?.meta?.message) {
        message = error.response.data.meta.message;
      } else if (error.message) {
        message = error.message;
      }

      dispatch({
        type: FETCH_PROJECT_ATTENDANCE_FAILURE,
        payload: message,
      });

      toast.error(message);
    }
  };
};